module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerpt0101",
      "epub:type": "part",
      "id": "pt01",
      "role": "doc-part"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerpt0101"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "11",
      "id": "p11",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chisites0006#toc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("I")])])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_vm._v("Birmingham")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p11"
    }
  }), _vm._v("Time, like much else in Sonny Blount’s Birmingham, was marked as white. In April 1917, African American newspaper publisher Oscar Adams predicted, in a public speech suffused with patriotic fervor, that with the coming end of the war his country would be ready to move beyond “race hatred, race prejudice, political supremacy, and political extravagance” to the “full triumph of the brotherhood of man.”")]), _vm._v(" "), _c('p', [_vm._v("An editorial response by the "), _c('i', [_vm._v("Birmingham News")]), _vm._v(" quickly snuffed out any promise of imminent brotherhood. Drawing on the race science of the period, the white-owned paper asserted bluntly, “There are superior and inferior races. In the processes of the suns some tribes got a million or so years the start of other tribes. No race of people, not the African people nor any other, can create an artificial stimulus that will "), _c('i', [_vm._v("overleap the barriers of time")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chisites0021#en21",
      "id": "en21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" African Americans, in this view, were permanently trapped in an earlier stage of human development—forever stuck in time.")]), _vm._v(" "), _c('p', [_vm._v("Blount, a young child in Birmingham when this exchange took place, would teach himself to avoid questions about time. He later refused, for example, to acknowledge his date of birth, and interviewers seeking to pin down the chronology of his life were met with evasive wordplay and paradox: “I don’t know the years. I wasn’t in a time zone.” Time, in any conventional sense, was a trap. Birth, he claimed, was in fact the beginning of death, a “berth” was a place for sleeping, and to “be-earthed” was to be buried. “A true birthday,” he would conclude, “is the day of your death.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chisites0021#en22",
      "id": "en22r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', [_vm._v("For Sonny Blount, time was a prison, especially for black Americans. But space, he discovered early on, might provide the key. Urban spaces promised to open up the present moment, whether in interwar Birmingham or postwar Chicago, into multiple times, from the ancient past to the distant yet somehow imminent future. If the “annihilation of space by time,” as Marx put it, has defined modern life—then perhaps space reimagined could expand temporality, even reverse or multiply it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chisites0021#en23",
      "id": "en23r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "12",
      "id": "p12",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The first half of the twentieth century, for all its brutal, relentless forward motion, offered strange new opportunities for using space to multiply time. And for African Americans in this period, the search for a hidden exit from the prison of race and history could take on a life of its own. In Blount’s Birmingham, it was making music that often furnished new spaces for time.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d989fe5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-sites-0009.vue
// module id = 78
// module chunks = 0